<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <DefectRateForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DefectRateForm from '@/components/organisms/report/form/DefectRateForm'

export default {
  name: 'DefectRatePage',
  components: { DefectRateForm },
}
</script>
